import React from "react";
import TSTable from "../common/TSTable";
import { Layout, message, Popconfirm, theme, Tooltip } from 'antd';
import HeaderScreen from "../common/HeaderScreen";
import * as _ from "lodash";
import { Content } from "antd/es/layout/layout";
import {
  PlusOutlined,
  PrinterOutlined,
  DeleteOutlined,
  EditOutlined
} from '@ant-design/icons';
import { PRINT_COLOR, SECONDARY_COLOR, WHITE_COLOR } from "../constants/color";
import { URL_SALE } from "../constants/urls";
import { useParams } from "react-router-dom";
import { DELETE, GET } from "../frameworks/HttpClient";
import { dateToHumanString, formatComma } from "../frameworks/Util";
import ColorButton from "../common/ColorButton";
import ProduceOrderModal from "../components/sale-list/ProduceOrderModal";
import { PRODUCT_TYPE } from "../constants/string";
import CustomDeleteConfirmButton from "../common/CustomDeleteConfirmButton";
import ErrorMessages from "../common/ErrorMessages";

export default function ProduceOrderScreen() {
  const params = useParams();
  const { token : { colorWarning, colorError, colorSuccess }} = theme.useToken();
  const [orderTarget, setOrderTarget] = React.useState(null);
  const [ saleOrderData, setSaleOrderData] = React.useState(null);
  const [errorMessages, setErrorMessages] = React.useState(null);
  const tableRef = React.useRef();

  const fetchSaleOrderData = async() => {
    setErrorMessages(null);
    try {
      if(params.type === PRODUCT_TYPE.CONCENTRATE_LATEX){
        const response = await GET(`${URL_SALE.SALE_ORDER}${params.id}/`)
        setSaleOrderData(response.data)
      } else {
        const response = await GET(`${URL_SALE.SKIM_SALE_ORDER}${params.id}/`)
        setSaleOrderData(response.data)
      }
    } catch (error) {
      setErrorMessages(error.errorMessages)
    }
  }

  const refreshData = async() => {
    if(tableRef.current)(
      await tableRef.current.fetchWithoutResetPage()
    )
  }

  const handleDelete = async (id) => {
    setErrorMessages(null);
    try {
      if(params.type === PRODUCT_TYPE.CONCENTRATE_LATEX){
        await DELETE(`${URL_SALE.PRODUCE_ORDER}${id}/`);
        message.success("ลบรายการสำเร็จ");
        refreshData();
      } else {
        await DELETE(`${URL_SALE.SKIM_PRODUCE_ORDER}${id}/`);
        message.success("ลบรายการสำเร็จ");
        refreshData();
      }
    } catch (error) {
      setErrorMessages(error.errorMessages);
    }
  };

  const columns = [
    {
      title : 'Action',
      dataIndex : '',
      key : 'action',
      render: (value, original) => (
        <div style={{ textAlign: 'center' }} onClick={(e) => e.stopPropagation()}>

          {/* <Tooltip triger='hover' title={"รายการแจ้งผลิต"}>
            <ColorButton 
              override={PRINT_COLOR}
              style={{ margin : 5}}
              type='primary'
              icon={<PrinterOutlined />}
              onClick={() => {}} 
            />
          </Tooltip> */}

          <CustomDeleteConfirmButton
            title={`ลบใบแจ้งผลิต - ${original.lot_no}`}
            content={"คุณต้องการลบใบแจ้งผลิตใช่หรือไม่"}
            onOk={ async() => {
              await handleDelete(original.id)
              refreshData();
            }}
            onConfirm={() => refreshData()}
          />

          <Tooltip triger='hover' title={"แก้ไขข้อมูล"}>
            <ColorButton 
              override={colorWarning}
              style={{ margin : 5}}
              type='primary'
              icon={<EditOutlined />}
              onClick={() =>  setOrderTarget(original)} 
            />
          </Tooltip>

        </div>
      )
    },
    {
      title : 'วันที่แจ้งผลิต',
      dataIndex : 'due_date',
      key : 'due_date',
      render : (value) => dateToHumanString(value)
    },
    {
      title : 'Lot No',
      dataIndex : 'lot_no',
      key : 'lot_no',
      searcher : true,
    },
    {
      title : 'ชื่อลูกค้า',
      dataIndex : 'buyer_name',
      key : 'buyer_name'
    },
    {
      title : 'สินค้าที่ต้องการ',
      dataIndex : 'product_name',
      key : 'product_name'
    },
    {
      title : 'ปริมาณผลิต(Kg)',
      dataIndex : 'require_weight',
      key : 'require_weight',
      render : (value) => <div style={{textAlign: "right"}}>{value ? formatComma(value) : '0'}</div>
    },
    {
      title : 'ปริมาณผลิต(ก้อน)',
      dataIndex : 'require_amount',
      key : 'require_amount',
      render : (value) => <div style={{textAlign: "right"}}>{value ? formatComma(value) : '0'}</div>,
      hidden : params.type === PRODUCT_TYPE.SKIM ? false : true,
    },
    {
      title : 'ผู้แจ้งผลิต',
      dataIndex : 'created_by_name',
      key : 'created_by_name'
    },
    {
      title : 'สถานะ',
      dataIndex : 'is_produced',
      key : 'is_produced',
      render : (value) => value ? 'ผลิตแล้ว' : 'รอผลิต'
    },
  ]

  React.useEffect(() => {
    fetchSaleOrderData();
  },[])

  React.useEffect(() => {
    if(saleOrderData){
      refreshData();
    }
  },[saleOrderData])

	return(
    <Layout>
      <HeaderScreen title={`รายการแจ้งผลิต - ${_.get(saleOrderData, 'order_no', '')}`} style={{ backgroundColor : SECONDARY_COLOR, color : WHITE_COLOR, fontSize : 18, fontWeight: 'bolder' }}/>
      <ErrorMessages message={errorMessages} style ={{ marginTop : 16}}/>
      <Content
        style={{
          margin: 24,
          minHeight: 280,
          padding: "0px 24px",
      }}>
        {saleOrderData && <ColorButton 
          type='primary'
          override={colorSuccess}
          icon={<PlusOutlined style={{ fontSize : 14 }}/>}
          onClick={()=> setOrderTarget('add')} 
          style={{ float : 'right', marginBottom : 10}}
        >
          เพิ่มรายการแจ้งผลิต
          </ColorButton> }
        {saleOrderData && <TSTable
          ref={tableRef}
          columns={columns}
          url={params.type === PRODUCT_TYPE.CONCENTRATE_LATEX ? URL_SALE.PRODUCE_ORDER : URL_SALE.SKIM_PRODUCE_ORDER}
          size={"small"}
          params={{sale_order : _.get(saleOrderData, 'id', '')}}
        />}
      </Content>

      <ProduceOrderModal
        open={orderTarget ? true : false}
        onClose={() => {
          setOrderTarget(null)
        }}
        onUpdate={() => {
          setOrderTarget(null)
          refreshData();
        }}
        target={orderTarget}
        saleOrder={saleOrderData}
      />
    </Layout>
)
}